import { useState } from "react";
import { entranceItems, faqItems } from "@/mocks/home";

export default function EntranceGuide() {
  const [openFaq, setOpenFaq] = useState<number | null>(1);

  return (
    <section id="guide" className="scroll-mt-20 border-t border-background-200/70 bg-background-100/40">
      <div className="mx-auto grid max-w-7xl gap-12 px-4 py-16 md:px-6 md:py-20 lg:grid-cols-2">
        {/* 左：入口醒目区 */}
        <div>
          <span className="inline-flex items-center gap-1.5 text-sm font-medium text-primary-600">
            <i className="ri-key-2-line"></i>
            入口指引
          </span>
          <h2 className="mt-2 font-heading text-3xl font-bold text-foreground-950 md:text-4xl">
            收藏本站，永远找得到
          </h2>
          <p className="mt-3 text-base leading-relaxed text-foreground-600">
            担心走丢？把下面这个步骤做一次，从此换址也不慌。
            页面会始终显示当前可用的正式与备用入口，让你随时顺利回来。
          </p>

          {/* 备用入口列表 */}
          <div className="mt-8 flex flex-col gap-3">
            {entranceItems.map((e) => (
              <div
                key={e.id}
                className="flex items-center gap-4 rounded-xl border border-background-200/70 bg-background-50 p-4"
              >
                <span
                  className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-full text-base ${
                    e.online === "在线"
                      ? "bg-secondary-100 text-secondary-700"
                      : "bg-background-200 text-foreground-500"
                  }`}
                >
                  <i className={e.online === "在线" ? "ri-link" : "ri-hourglass-line"}></i>
                </span>
                <div className="min-w-0 flex-1">
                  <p className="text-sm font-semibold text-foreground-900">{e.label}</p>
                  <p className="truncate text-sm text-foreground-500">{e.address}</p>
                </div>
                <span
                  className={`whitespace-nowrap rounded-full px-3 py-1 text-xs font-medium ${
                    e.online === "在线"
                      ? "bg-secondary-100 text-secondary-700"
                      : "bg-background-200 text-foreground-500"
                  }`}
                >
                  {e.status}
                </span>
              </div>
            ))}
          </div>

          {/* 三步收藏 */}
          <div className="mt-8 grid gap-4 sm:grid-cols-3">
            {[
              { n: "1", t: "打开本站", d: "确认页面能正常访问", i: "ri-global-line" },
              { n: "2", t: "加入收藏", d: "把入口存入浏览器书签", i: "ri-bookmark-line" },
              { n: "3", t: "随时回来", d: "换址后仍从收藏进入", i: "ri-home-smile-line" },
            ].map((s) => (
              <div key={s.n} className="rounded-xl bg-background-50 p-4">
                <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-sm font-semibold text-background-50">
                  {s.n}
                </span>
                <p className="mt-3 flex items-center gap-1.5 text-sm font-semibold text-foreground-950">
                  <i className={s.i}></i>
                  {s.t}
                </p>
                <p className="mt-1 text-xs leading-relaxed text-foreground-500">{s.d}</p>
              </div>
            ))}
          </div>
        </div>

        {/* 右：FAQ */}
        <div>
          <span className="inline-flex items-center gap-1.5 text-sm font-medium text-secondary-700">
            <i className="ri-question-line"></i>
            常见问题
          </span>
          <h2 className="mt-2 font-heading text-3xl font-bold text-foreground-950 md:text-4xl">
            关于入口，你可能想问
          </h2>

          <div className="mt-7 flex flex-col gap-3">
            {faqItems.map((f) => {
              const active = openFaq === f.id;
              return (
                <div
                  key={f.id}
                  className="overflow-hidden rounded-xl border border-background-200/70 bg-background-50"
                >
                  <button
                    onClick={() => setOpenFaq(active ? null : f.id)}
                    className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                  >
                    <span className="text-sm font-semibold text-foreground-950 md:text-base">
                      {f.q}
                    </span>
                    <i
                      className={`text-lg text-primary-500 transition-transform ${
                        active ? "ri-subtract-line" : "ri-add-line"
                      }`}
                    ></i>
                  </button>
                  {active && (
                    <p className="px-5 pb-5 text-sm leading-relaxed text-foreground-600">
                      {f.a}
                    </p>
                  )}
                </div>
              );
            })}
          </div>

          <a
            href="#top"
            className="mt-6 inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-5 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-accent-600"
          >
            <i className="ri-bookmark-fill text-base"></i>
            立即收藏本站，吃瓜不迷路
          </a>
        </div>
      </div>
    </section>
  );
}